import React from "react";

import { ApiErrorDialogProvider } from "./apiErrorDialog";
import { AuthProvider } from "./auth";
import { LoaderProvider } from "./loading";

const AppProvider: React.FC = ({ children }) => (
  <LoaderProvider>
    <ApiErrorDialogProvider>
      <AuthProvider>{children}</AuthProvider>
    </ApiErrorDialogProvider>
  </LoaderProvider>
);

export default AppProvider;
